module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/csv-6fcad382022a8efdb7545bd381e1df1e.svg";